import { Layout } from 'antd'
import { Route, Switch } from 'react-router-dom'
import SelectPackType from '../upload/SelectPackType'
import CreatePackageInfo from './CreatePackageInfo'
// How many mutations are fetching?

export default function CreatePackageLayout() {
  // How many mutations matching the posts prefix are fetching?
  return (
    <Layout style={{ height: 'inherit', background: 'white' }}>
      <Layout.Content>
        <Switch>
          <Route
            path="/upload/create-package/:packType/:movingStatus"
            component={CreatePackageInfo}
          />
          <Route path="/upload/create-package" component={SelectPackType} />
        </Switch>
      </Layout.Content>
    </Layout>
  )
}
